module.exports = __webpack_public_path__ + "media/images/banner_calculator-a291e18c5233dddc54a4a2807885c284.webp";